import { useTranslate } from "ra-core";
import { TasksListByDueDate } from "./TasksListByDueDate";

export function ActivitiesPage() {
  const translate = useTranslate();

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-semibold tracking-tight">
        {translate("crm.nav.activities", { _: "Actividades" })}
      </h1>
      <TasksListByDueDate />
    </div>
  );
}
